
export default {
  data() {
    return {
    }
  },
  methods: {
    // 支付图标
    supportPayIcon(paymentType) {
      let pay_icon = require("@/assets/imgs/icon_creditcard.png")
      let p_type = paymentType && paymentType.toLocaleUpperCase()
      if (p_type.includes("GOOGLE")) {
        pay_icon = require("@/assets/imgs/icon_googlepay.png")
      } else if (p_type.includes("APPLE")) {
        pay_icon = require("@/assets/imgs/icon_applepay.png")
      } else if (p_type.includes("PAYPAL")) {
        pay_icon = require("@/assets/imgs/icon_paypal.png")
      }

      return pay_icon;
    },
    /**
     * 支持的支付类型适配
     * @param [{pPaymentType}] model 
     */
    supportPayMode(model) {
      let payModel = model.map((v = {}) => {
        const pPaymentType = v.pPaymentType;
        v.pay_icon = this.supportPayIcon(pPaymentType)
        if (pPaymentType === "STRIPE_CARD") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (
          pPaymentType === "STRIPE_WECHAT" ||
          pPaymentType === "WeChat_MP"
        ) {
          v.label = "WeChat"
          v.phone = "wechat"
        } else if (pPaymentType === "PAYPAL") {
          v.label = "PayPal"
          v.phone = "all"
        } else if (
          (pPaymentType === "APPLE_PAY" ||
            pPaymentType === "STRIPE_APPLE") && this.system === 'ios'
        ) {
          v.label = "Apple Pay"
          v.phone = "ios"
        } else if (
          (pPaymentType === "GOOGLE_PAY" ||
            pPaymentType === "STRIPE_GOOGLE")
        ) {
          v.label = "Google Pay"
          v.phone = "android"
        } else if (pPaymentType === "M-PESA") {
          v.label = "SMS Payment"
          v.phone = "all"
        } else if (pPaymentType === "STRIPE_IDAEL" ||
          pPaymentType === "STRIPE_IDEAL") {
          v.label = "Idael Pay"
          v.phone = "all"
        } else if (pPaymentType === "MercadoPago") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "Flutterwave_Mobile") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "SumUpOnlinePayment") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "Espees") {
          v.label = "Credit Card"
          v.phone = "all"
        } else {
          v.label = "Unknow"
          v.phone = "null"
        }
        return v
      })
      payModel = payModel.filter((v) => {
        return v.label !== "Unknow";
      })
      return payModel
    },
  }
}
